(ns common.i18n.dictionary
  (:require [common.i18n.lang.en :as en]
            [common.i18n.lang.es :as es]))

;; `append-ns` and `build-dict` were taken from tongue to support the tranlsation macros
(defn append-ns [ns segment]
  (str (when ns (str ns "."))
       segment))

(defn build-dict
  "Collapses nested maps into namespaced keywords:
   { :ns { :key 1 }} => { :ns/key 1 }
   { :animal { :flying { :bird 420 }}} => { :animal.flying/bird 420 }"
  ([dict] (build-dict nil dict))
  ([ns dict]
    (reduce-kv
      (fn [aggr key value]
        (cond
          (= "tongue" (namespace key))
          (do
            (assert (nil? ns) ":tongue/... keys can only be specified at top level")
            (assoc aggr key value))

          (map? value)
          (merge aggr (build-dict (append-ns ns (name key)) value))

          :else
          (assoc aggr (keyword (or ns (namespace key)) (name key)) value)))
      {} dict)))

;;
;; Nested structures can not contain namespaced keys (limitation of tongue)
;;

(def dictionaries
  {:en              en/dictionary
   :es              es/dictionary
   :test            (->> en/dictionary
                         (map (fn [[k _]] {k (str "!QA!-" (name k))}))
                         (apply merge))
   :tongue/fallback :en})
